import React from "react";

import { TitleText } from "./title.styles";
const Title = ({ children }) => <TitleText>{children}</TitleText>;

export default Title;
